import React from 'react'
import PropTypes from 'prop-types'
import BlogPage from '../../components/pages/BlogPage'
import { graphql } from 'react-apollo'
import loadBlog from './loadBlog.gql'

const BlogPageContainer = props => {
  const { data, game, globalContent, globalComponents, enableContentful, path } = props
  const { loading, games, contentfulBlogs = [], error } = data

  if (!loading && error) {
    return error
  }
  return (
    <BlogPage
      post={game}
      posts={loading ? [] : (games ?? contentfulBlogs).filter((item) => item.id !== game.id)}
      globalContent={globalContent}
      globalComponents={globalComponents}
      enableContentful={enableContentful}
      path={path}
    />
  )
}

const BlogPageContainerWithData = graphql(loadBlog, {
  options: (props) => {
    const variables = {
      categoryId: 'blog',
      released: true,
      limit: 10,
      sort: props?.enableContentful ? 'title' : 'added',
      enableContentful: props?.enableContentful ?? false
    }
    if (props.game?.tags.length > 0) {
      variables.tags = props.game.tags.map(tag => tag.value)
    } else {
      variables.subCategoryId = props.game.subCategoryId
    }
    return {
      variables
    }
  }
})(BlogPageContainer)

BlogPageContainer.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    games: PropTypes.array,
    error: PropTypes.object,
    contentfulBlogs: PropTypes.array
  }),
  game: PropTypes.shape({
    id: PropTypes.string,
    visible: PropTypes.bool,
    providerId: PropTypes.string,
    subCategoryId: PropTypes.string,
    title: PropTypes.string,
    jsonld: PropTypes.string,
    pageFooterOverride: PropTypes.object,
    overrideComponents: PropTypes.object
  }),
  globalContent: PropTypes.object,
  globalComponents: PropTypes.object,
  enableContentful: PropTypes.bool,
  path: PropTypes.string
}

export default BlogPageContainerWithData
